export const palette = {
  id: 'harvest',
  displayName: 'Harvest',
  graph: {
    writeSample: '#E07020', writeTrend: 'rgba(224, 112, 32, 0.67)',
    writeMax: '#F0A050', writeMin: '#8B3A0A', writeLatency: '#E07020',
    readSample: '#5A7A40', readTrend: 'rgba(90, 122, 64, 0.67)',
    readMax: '#8AAA68', readMin: '#354D22', readLatency: '#5A7A40',
  },
  canvas: {
    chartBg: '#FFF8EE', gridColor: '#E8D8C0', textColor: '#3B1F0A',
  },
};

const harvest = {
  id: 'harvest',
  displayName: 'Harvest',
  baseType: 'light',
  enabled: false,
  linkedPalette: 'harvest',
  palette,
  ui: {
    headerBg: '#FFF8EE', headerText: '#3B1F0A', accentColor: '#D4920A',
    mainBg: '#FFF0D0', mainText: '#3B1F0A', mainTextHeading: '#3B1F0A',
    mainHeroText: '#FFFFFF', footerBg: '#FFF8EE', footerText: '#3B1F0A',
    cardBg: '#FFFFFF', cardText: '#3B1F0A', cardBorder: '#C45C11',
    cardButtonBg: '#C45C11', cardButtonText: '#FFFFFF',
    navLinkText: '#3B1F0A', navLinkHover: '#C45C11', navLinkActive: '#3B1F0A',
    listGroupBg: '#FFF0D0', bmrkDetailBg: '#C45C11',
    bmrkMetricBg: '#FFFFFF', bmrkMetricText: '#3B1F0A', bmrkMetricBorder: '#C45C11',
    mainCardText: '#3B1F0A', navLinkFocus: '#3B1F0A', navEmailActive: '#3B1F0A',
    homeProseLabel: '#C45C11', homeProseLink: '#3B1F0A', homeProseDlBtn: '#3B1F0A',
    cardButtonBorder: '#C45C11', linkColor: '#C45C11', cardTextMuted: '#786456',
  },
};
export default harvest;
